/* 0.46.64 - Keeps the lines of the content around it aligned by their
 * elements' main parts (lib/mainAlign.js). A hidden mark whose PARENT
 * is the root watched: the page renderer and the preview have no single
 * root element of their own. */
import React, { useEffect, useRef } from 'react';
import { watchMainAlign } from '../lib/mainAlign';

export default function MainAlignAnchor() {
  const ref = useRef(null);
  useEffect(() => {
    const root = ref.current && ref.current.parentElement;
    return watchMainAlign(root);
  }, []);
  return <span ref={ref} hidden data-main-align-anchor="" />;
}
